import { FC } from 'react';

import BusinessButton from '../../business-button/business-button';
import { COLOR, POSITION, SIZE, SIZES } from '../../business-button/business-button.constants';
import styles from './b2b-list-card-resources.module.scss';
import { IconType } from '../../icons';

export interface B2BListCardResourcesProps {
    backgroundCard?: string;
    buttonBackground?: COLOR;
    showListNameCard?: boolean;
    quantityColumnCard?: number;
    buttonFullWidthMobile?: boolean;
    buttonPadding?: string;
    buttonTextSize?: SIZE;
    buttonPaddingMobile?: string;
    paddingContentCartMobile?: string;
    heightImageCardMobile?: string;
    minHeightCardMobile?: string;
    gapListCardMobile?: string;

    card?: {
        image?: string;
        title?: string;
        description?: string;
        fontSizeDescription?: number;
        link?: string;
        buttonText?: string;
        iconType?: IconType;
    }[];
}

const BusinessHubListCardResources: FC<B2BListCardResourcesProps> = (props) => {
    const {
        card,
        backgroundCard,
        buttonBackground,
        showListNameCard,
        quantityColumnCard,
        buttonFullWidthMobile,
        buttonPadding,
        buttonTextSize,
        buttonPaddingMobile,
        paddingContentCartMobile,
        heightImageCardMobile,
        minHeightCardMobile,
        gapListCardMobile
    } = props;

    const handleScrollTovView = (index: number) => {
        const element = document.querySelectorAll(`.${styles.card}`)[index];

        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.wrapperContent}>
                {showListNameCard && (
                    <div className={styles.wrapperListNameCard}>
                        {card?.map((item, index) => (
                            <div key={index} className={styles.nameCard} onClick={() => handleScrollTovView(index)}>
                                <span dangerouslySetInnerHTML={{ __html: item.title || '' }}></span>
                            </div>
                        ))}
                    </div>
                )}

                <div
                    className={styles.wrapperCard}
                    style={{
                        ...{gridTemplateColumns: `repeat(${quantityColumnCard}, 1fr)`},
                        ...(gapListCardMobile ? ({ '--gap-list-card-mobile': gapListCardMobile } as React.CSSProperties) : {}),
                    }}
                >
                    {card?.map((item, index) => (
                        <div
                            key={index}
                            className={styles.card}
                            style={{
                                ...(minHeightCardMobile ? ({ '--mint-height-cart-mobile': minHeightCardMobile } as React.CSSProperties) : {}),
                            }}
                        >
                            <div
                                className={styles.cardImage}
                                style={{
                                    ...(heightImageCardMobile ? ({ '--height-image-cart-mobile': heightImageCardMobile } as React.CSSProperties) : {}),
                                }}
                            >
                                <img src={item.image} alt={item.title} />
                            </div>

                            <div
                                className={styles.cardContent}
                                style={{
                                    ...{ background: backgroundCard },
                                    ...(paddingContentCartMobile ? ({ '--padding-content-cart-mobile': paddingContentCartMobile } as React.CSSProperties) : {}),
                                }}
                            >
                                <div className={styles.content}>
                                    <div className={styles.title} dangerouslySetInnerHTML={{ __html: item.title || '' }}></div>

                                    <div
                                        className={styles.description}
                                        style={item.fontSizeDescription ? { fontSize: `${item.fontSizeDescription}px` } : {}}
                                        dangerouslySetInnerHTML={{ __html: item.description || '' }}
                                    ></div>
                                </div>
                                {item.link && item.buttonText ? (
                                    <div
                                        className={styles.readMore}
                                        style={{
                                            ...(buttonFullWidthMobile ? ({ '--button-width': '100%' } as React.CSSProperties) : {}),
                                            ...(buttonPadding ? ({ '--button-padding': buttonPadding } as React.CSSProperties) : {}),
                                            ...(buttonPaddingMobile ? ({ '--button-padding-mobile': buttonPaddingMobile } as React.CSSProperties) : {}),
                                        }}
                                    >
                                        <BusinessButton
                                            link={item.link}
                                            buttonText={item.buttonText || 'Read more'}
                                            position={POSITION.LEFT}
                                            color={buttonBackground}
                                            autoMargin={false}
                                            icon={item.iconType ? item.iconType : undefined}
                                            size={buttonTextSize}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BusinessHubListCardResources;
